var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _path5, _circle, _path6, _path7, _circle2, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _circle3, _polygon;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTip5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ad1dd13e-2ec4-4c24-88e7-d38d592282c0",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 578,
    height: 675,
    viewBox: "0 0 578 675",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sync_files") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M694,112.5H324a13.01442,13.01442,0,0,0-13,13v500a13.01474,13.01474,0,0,0,13,13H694a13.01505,13.01505,0,0,0,13-13v-500A13.01474,13.01474,0,0,0,694,112.5Z",
    transform: "translate(-311 -112.5)",
    fill: "#f2f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M335.42966,128.5A9.08459,9.08459,0,0,0,326.5,137.71212V613.28788A9.08459,9.08459,0,0,0,335.42966,622.5H682.57034A9.08459,9.08459,0,0,0,691.5,613.28788V137.71212A9.08459,9.08459,0,0,0,682.57034,128.5Z",
    transform: "translate(-311 -112.5)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M353.5,150.5c-3.30859,0-6,3.03744-6,6.77143v65.45714c0,3.734,2.69141,6.77143,6,6.77143h311c3.30859,0,6-3.03744,6-6.77143V157.27143c0-3.734-2.69141-6.77143-6-6.77143Z",
    transform: "translate(-311 -112.5)",
    fill: "#e6e6e6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M353.5,261.25a6.09464,6.09464,0,0,0-6,6.1723V407.3277a6.09464,6.09464,0,0,0,6,6.1723h311a6.09464,6.09464,0,0,0,6-6.1723V267.4223a6.09464,6.09464,0,0,0-6-6.1723Z",
    transform: "translate(-311 -112.5)",
    fill: "#e6e6e6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 47.25,
    width: 246,
    height: 14,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 75.5,
    y: 76.75,
    width: 246,
    height: 6.5,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 75.5,
    y: 88.25,
    width: 246,
    height: 6.5,
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 75.5,
    y: 99.75,
    width: 246,
    height: 6.5,
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M532.1626,413.75H645.37354a3.6445,3.6445,0,0,0,2.57714-6.22119l-72.45654-72.45654a3.64844,3.64844,0,0,0-5.15381,0l-18.01806,18.01806a7.64285,7.64285,0,0,1-10.81006,0l-56.43506-56.43506a3.64905,3.64905,0,0,0-5.1543,0L369.54932,407.02881a3.6445,3.6445,0,0,0,2.57714,6.22119H532.30762Z",
    transform: "translate(-311 -112.5)",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 86.5,
    cy: 181.75,
    r: 14,
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M353.5,446.25a6.09464,6.09464,0,0,0-6,6.1723V592.3277a6.09464,6.09464,0,0,0,6,6.1723h311a6.09464,6.09464,0,0,0,6-6.1723V452.4223a6.09464,6.09464,0,0,0-6-6.1723Z",
    transform: "translate(-311 -112.5)",
    fill: "#e6e6e6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M532.1626,598.75H645.37354a3.64489,3.64489,0,0,0,2.57714-6.22168l-72.45654-72.456a3.6502,3.6502,0,0,0-5.15381,0l-18.01806,18.01757a7.64107,7.64107,0,0,1-10.81055,0l-56.43457-56.43457a3.65082,3.65082,0,0,0-5.1543,0L369.54932,592.02832a3.64489,3.64489,0,0,0,2.57714,6.22168H532.30762Z",
    transform: "translate(-311 -112.5)",
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 86.5,
    cy: 366.75,
    r: 14,
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M454,227.5a9.01047,9.01047,0,0,0-9,9v500a9.01016,9.01016,0,0,0,9,9H824a9.00984,9.00984,0,0,0,9-9v-500a9.01016,9.01016,0,0,0-9-9Z",
    transform: "translate(-311 -112.5)",
    fill: "#e6e6e6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M464.92966,241.5A9.08459,9.08459,0,0,0,456,250.71212V726.28788A9.08459,9.08459,0,0,0,464.92966,735.5H812.07034A9.08459,9.08459,0,0,0,821,726.28788V250.71212A9.08459,9.08459,0,0,0,812.07034,241.5Z",
    transform: "translate(-311 -112.5)",
    fill: "#fff"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M519.25,310.68262a4.00458,4.00458,0,0,0-4,4V333.0415a4.00458,4.00458,0,0,0,4,4h236a4.00427,4.00427,0,0,0,4-4V314.68262a4.00427,4.00427,0,0,0-4-4Z",
    transform: "translate(-311 -112.5)",
    fill: "#edd84f"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M517.75,371.439a1.00131,1.00131,0,0,0-1,1v7.167a1.0013,1.0013,0,0,0,1,1h240a1.001,1.001,0,0,0,1-1v-7.167a1.001,1.001,0,0,0-1-1Z",
    transform: "translate(-311 -112.5)",
    fill: "#ccc"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M517.75,394.73389a1.0013,1.0013,0,0,0-1,1v7.167a1.0013,1.0013,0,0,0,1,1h240a1.001,1.001,0,0,0,1-1v-7.167a1.001,1.001,0,0,0-1-1Z",
    transform: "translate(-311 -112.5)",
    fill: "#ccc"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M517.75,418.02881a1.0013,1.0013,0,0,0-1,1v7.1665a1.0013,1.0013,0,0,0,1,1h240a1.001,1.001,0,0,0,1-1v-7.1665a1.001,1.001,0,0,0-1-1Z",
    transform: "translate(-311 -112.5)",
    fill: "#ccc"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M517.25,464.561a1.0013,1.0013,0,0,0-1,1v7.1665a1.0013,1.0013,0,0,0,1,1h240a1.001,1.001,0,0,0,1-1V465.561a1.001,1.001,0,0,0-1-1Z",
    transform: "translate(-311 -112.5)",
    fill: "#ccc"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M517.25,487.856a1.0013,1.0013,0,0,0-1,1v7.1665a1.0013,1.0013,0,0,0,1,1h240a1.001,1.001,0,0,0,1-1V488.856a1.001,1.001,0,0,0-1-1Z",
    transform: "translate(-311 -112.5)",
    fill: "#ccc"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M517.25,511.15039a1.001,1.001,0,0,0-1,1v7.167a1.001,1.001,0,0,0,1,1h240a1.00067,1.00067,0,0,0,1-1v-7.167a1.00067,1.00067,0,0,0-1-1Z",
    transform: "translate(-311 -112.5)",
    fill: "#ccc"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M517.25,534.56055a1.001,1.001,0,0,0-1,1v7.167a1.001,1.001,0,0,0,1,1h240a1.00067,1.00067,0,0,0,1-1v-7.167a1.00067,1.00067,0,0,0-1-1Z",
    transform: "translate(-311 -112.5)",
    fill: "#ccc"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M517.25,557.85547a1.001,1.001,0,0,0-1,1v7.167a1.001,1.001,0,0,0,1,1h240a1.00067,1.00067,0,0,0,1-1v-7.167a1.00067,1.00067,0,0,0-1-1Z",
    transform: "translate(-311 -112.5)",
    fill: "#ccc"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M517.25,581.15039a1.001,1.001,0,0,0-1,1v7.167a1.001,1.001,0,0,0,1,1h240a1.00067,1.00067,0,0,0,1-1v-7.167a1.00067,1.00067,0,0,0-1-1Z",
    transform: "translate(-311 -112.5)",
    fill: "#ccc"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M517.25,604.56055a1.001,1.001,0,0,0-1,1v7.167a1.001,1.001,0,0,0,1,1h240a1.00067,1.00067,0,0,0,1-1v-7.167a1.00067,1.00067,0,0,0-1-1Z",
    transform: "translate(-311 -112.5)",
    fill: "#ccc"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M517.25,627.85547a1.001,1.001,0,0,0-1,1v7.167a1.001,1.001,0,0,0,1,1h240a1.00067,1.00067,0,0,0,1-1v-7.167a1.00067,1.00067,0,0,0-1-1Z",
    transform: "translate(-311 -112.5)",
    fill: "#ccc"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M517.25,651.15039a1.001,1.001,0,0,0-1,1v7.167a1.001,1.001,0,0,0,1,1h240a1.00067,1.00067,0,0,0,1-1v-7.167a1.00067,1.00067,0,0,0-1-1Z",
    transform: "translate(-311 -112.5)",
    fill: "#ccc"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 505,
    cy: 602,
    r: 73,
    fill: "#edd84f"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "498.044 632.815 476.194 604.723 488.9 594.839 499.246 608.141 534.195 571.248 545.882 582.32 498.044 632.815",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTip5);
export default __webpack_public_path__ + "static/media/tip5.6f9c38df1ce2af0549af4418fb47beec.svg";
export { ForwardRef as ReactComponent };